import { REGEX_RM_BR_OR_URL, REGEX_TAG_MEDIA } from "./regex";

export function postExcerpt(description: string, length = 100): string {
  const test = new RegExp(/[,:(. \n]/);
  let cont = length;
  let desc = "";
  desc = description;
  if (desc?.includes("sc_playlist") || desc?.includes("sc_track")) return "";
  if (description?.length > length) {
    desc = description?.slice(0, length);
    while (cont <= description?.length - 1) {
      if (test.test(description[cont])) break;
      desc += description[cont];
      cont++;
    }
    desc += "...";
  }

  return desc;
}

export const removeMediaTags = (content: string) =>
  content?.replace(REGEX_RM_BR_OR_URL, "")?.replace(REGEX_TAG_MEDIA, "");
